import React from 'react';
import { Animated } from 'react-native';

import { AnimatedCardContext } from './animated-card-context';
import type { AnimatedCardChildType } from './animated-card-types';

export const AnimatedCardHeader: React.FC<AnimatedCardChildType> = ({
  children,
  style,
}): JSX.Element => (
  <AnimatedCardContext.Consumer>
    {(value) => (
      <Animated.View
        style={[
          style,
          {
            opacity: value?.interpolate({
              inputRange: [0, 0.3, 1],
              outputRange: [0, 0, 1],
            }),
          },
        ]}
      >
        {children}
      </Animated.View>
    )}
  </AnimatedCardContext.Consumer>
);
